// src/email/components/FolderSidebar.jsx
import React from 'react';

const FOLDERS = [
  {
    key: 'inbox',
    label: 'Inbox',
    icon: (active) => (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
        <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
      </svg>
    ),
  },
  {
    key: 'sent',
    label: 'Sent',
    icon: (active) => (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <line x1="22" y1="2" x2="11" y2="13" />
        <polygon points="22 2 15 22 11 13 2 9 22 2" />
      </svg>
    ),
  },
  {
    key: 'drafts',
    label: 'Drafts',
    icon: (active) => (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    key: 'spam',
    label: 'Spam',
    icon: (active) => (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
  },
  {
    key: 'trash',
    label: 'Trash',
    icon: (active) => (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </svg>
    ),
  },
  {
    key: 'all',
    label: 'All Mail',
    icon: (active) => (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 2.2 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
  },
];

/**
 * Live folder navigation with count badges refreshed in real time.
 */
export function FolderSidebar({ counts, activeFolder, onSelect, isCollapsed = false }) {
  return (
    <nav className={`folder-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {FOLDERS.map((f) => {
        const isActive = activeFolder === f.key;
        // Inbox shows its unread count rather than the total
        const count = counts?.[f.key === 'inbox' ? 'unread' : f.key] ?? 0;
        return (
          <button
            key={f.key}
            type="button"
            className={`folder-row ${isActive ? 'active' : ''} ${isCollapsed ? 'collapsed' : ''}`}
            onClick={() => onSelect(f.key)}
            title={
              isCollapsed
                ? `${f.label}${count > 0 ? ` (${count}${f.key === 'inbox' ? ' unread' : ''})` : ''}`
                : undefined
            }
          >
            <span className={`folder-icon ${isActive ? 'icon-active' : ''}`}>
              {f.icon(isActive)}
              {isCollapsed && count > 0 && (
                <span className={`folder-mini-badge ${f.key === 'inbox' ? 'count-highlight' : ''}`}>
                  {count > 99 ? '99+' : count}
                </span>
              )}
            </span>
            {!isCollapsed && <span className="folder-label">{f.label}</span>}
            {!isCollapsed && count > 0 && (
              <span className={`folder-count ${f.key === 'inbox' ? 'count-highlight' : ''}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
